import { combineReducers } from 'redux'
import locationReducer from './location'
import clientsReducer from './clients'
import devicesReducer from './devices'
import deviceHistoryReducer from './deviceHistory'
import jobsReducer from './jobs'
import organizationsReducer from './organizations'
import pharmaciesReducer from './pharmacies'
import prescribersReducer from './prescribers'
import sitesReducer from './sites'
import userReducer, { LOGOUT } from './user'
import qcReducer from './qc'
import uiReducer from './ui'
import versionsReducer from './versions'
import controlMaterialsReducer from './controlMaterials.js'
import patientsReducer from './patients.js'

export const makeRootReducer = (asyncReducers) => {
  const combinedReducer = combineReducers({
    location: locationReducer,
    clients: clientsReducer,
    devices: devicesReducer,
    deviceHistory: deviceHistoryReducer,
    jobs: jobsReducer,
    user: userReducer,
    ui: uiReducer,
    qc: qcReducer,
    versions: versionsReducer,
    organizations: organizationsReducer,
    prescribers: prescribersReducer,
    sites: sitesReducer,
    pharmacies: pharmaciesReducer,
    controlMaterials: controlMaterialsReducer,
    patients: patientsReducer,
    ...asyncReducers
  })

  return (state, action) => {
    // clear stores on logout
    if (action.type === LOGOUT) {
      state = undefined
    }

    return combinedReducer(state, action)
  }
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js